/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Applicant,
  ApplicantLoginPayloadRequest,
  ErrorResponse,
  TokenObtainPair,
  TokenObtainPairRequest,
  TokenRefresh,
  TokenRefreshRequest,
} from '../models';
import {
    ApplicantFromJSON,
    ApplicantToJSON,
    ApplicantLoginPayloadRequestFromJSON,
    ApplicantLoginPayloadRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    TokenObtainPairFromJSON,
    TokenObtainPairToJSON,
    TokenObtainPairRequestFromJSON,
    TokenObtainPairRequestToJSON,
    TokenRefreshFromJSON,
    TokenRefreshToJSON,
    TokenRefreshRequestFromJSON,
    TokenRefreshRequestToJSON,
} from '../models';

export interface AuthApplicantCreateRequest {
    applicantLoginPayloadRequest: ApplicantLoginPayloadRequest;
}

export interface AuthLoginCreateRequest {
    tokenObtainPairRequest: TokenObtainPairRequest;
}

export interface AuthRefreshCreateRequest {
    tokenRefreshRequest: TokenRefreshRequest;
}

/**
 * 
 */
export class AuthApi extends runtime.BaseAPI {

    /**
     */
    async authApplicantCreateRaw(requestParameters: AuthApplicantCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Applicant>> {
        if (requestParameters.applicantLoginPayloadRequest === null || requestParameters.applicantLoginPayloadRequest === undefined) {
            throw new runtime.RequiredError('applicantLoginPayloadRequest','Required parameter requestParameters.applicantLoginPayloadRequest was null or undefined when calling authApplicantCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/auth/applicant`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicantLoginPayloadRequestToJSON(requestParameters.applicantLoginPayloadRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicantFromJSON(jsonValue));
    }

    /**
     */
    async authApplicantCreate(requestParameters: AuthApplicantCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Applicant> {
        const response = await this.authApplicantCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
     */
    async authLoginCreateRaw(requestParameters: AuthLoginCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TokenObtainPair>> {
        if (requestParameters.tokenObtainPairRequest === null || requestParameters.tokenObtainPairRequest === undefined) {
            throw new runtime.RequiredError('tokenObtainPairRequest','Required parameter requestParameters.tokenObtainPairRequest was null or undefined when calling authLoginCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/auth/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TokenObtainPairRequestToJSON(requestParameters.tokenObtainPairRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenObtainPairFromJSON(jsonValue));
    }

    /**
     * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
     */
    async authLoginCreate(requestParameters: AuthLoginCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TokenObtainPair> {
        const response = await this.authLoginCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     */
    async authRefreshCreateRaw(requestParameters: AuthRefreshCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TokenRefresh>> {
        if (requestParameters.tokenRefreshRequest === null || requestParameters.tokenRefreshRequest === undefined) {
            throw new runtime.RequiredError('tokenRefreshRequest','Required parameter requestParameters.tokenRefreshRequest was null or undefined when calling authRefreshCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/auth/refresh`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TokenRefreshRequestToJSON(requestParameters.tokenRefreshRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenRefreshFromJSON(jsonValue));
    }

    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     */
    async authRefreshCreate(requestParameters: AuthRefreshCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TokenRefresh> {
        const response = await this.authRefreshCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
